import styled from "styled-components";
import bg from "./res/bg.png";

import { colors } from "../../config/colors";

export const Form = styled.form`
  position: relative;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 15px;

  div label {
    color: white;
    font-size: 14px;
  }

  div {
    color: white;
  }
  div input {
    margin-bottom: 10px;
    background-color: rgb(255, 255, 255, 0.2);
    border-top: none;
    border-left: none;
    border-right: none;
    color: white;
  }

  button {
    position: relative;
    width: 60%;
    background-color: white;
    color: ${colors.primary};
    height: 50px;
    font-size: 14px;
    font-weight: bold;
    border-radius: 10px;
    top: 12px;
    transition: ease 500ms;

    :hover {
      background-color: ${colors.primary};
      color: white;
    }
  }
  .fieldError {
    color: red;
    font-size: 10px;
    height: 10px;
    padding-bottom: 3px;
  }
`;

export const Background = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: ${colors.primaryDark};
  background-image: url(${bg});
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  .out-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    color: #ffffff;
    font-size: 20px;

    span {
      position: relative;
      top: -30px;
    }
  }
  .logo {
    position: relative;
    top: -50px;
    height: 60px;
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 250px;
    width: 320px;
    border: 1px solid #ffffff;
    border-radius: 20px;
    z-index: 1;
    color: #ffffff;

    .title {
      display: flex;
      align-items: top;
      justify-content: center;
      width: 50%;
      height: 30px;
      position: relative;
      top: 10px;
      border-bottom: 1px solid;
      padding-bottom: 10px;
    }

    h1 {
      font-weight: lighter;
      font-size: 18px;
    }
  }

  .image {
    position: relative;
    right: 290px;
    top: 50px;
    height: 300px;
    z-index: 2;
  }
`;
